import { Component, OnInit, Inject, LOCALE_ID } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthService } from "../../core/services/auth/auth.service";
import { HttpParams } from "@angular/common/http";
import { GetLoginUserResponse } from "../../core/data/models/get-login-user-response";
import { LoginUser } from "../../core/data/models/login-user";
import { MatDialog } from "@angular/material/dialog";
import { Unit } from "../../core/data/models/unit";
import { MeterConfirmDialogInfo } from "../../core/data/models/meter-confirm-dialog-info";
import { CommonConfirmDialogComponent } from "../common-confirm-dialog/common-confirm-dialog.component";
import { MeterUnitAddDialogComponent } from "../meter-unit-add-dialog/meter-unit-add-dialog.component";
import { MeterUnitEditDialogComponent } from "../meter-unit-edit-dialog/meter-unit-edit-dialog.component";
import { Const } from "../../core/data/models/const";
import { Subject } from "rxjs";
import { UnitsApi } from "src/app/core/api/units.api";

@Component({
  selector: "app-meter-unit",
  templateUrl: "./meter-unit.component.html",
  styleUrls: ["./meter-unit.component.scss"],
})
export class MeterUnitComponent implements OnInit {
  loginUser: LoginUser = Const.loginUser;
  getLoginUserUrl: string;
  getLoginUserResponse: GetLoginUserResponse;
  getTenantDataUrl: string;

  // テーブル生成用
  displayedColumns: string[];
  meterUnitData: Unit[];
  filteredMeterUnitData: Unit[];

  searchKeyString: string = "";
  searchKeyChanged: Subject<string> = new Subject<string>();

  // フラグ類
  getUserFinished: boolean;
  getMeterUnitFinished: boolean;
  mjitUserFlag = false;
  adminUserFlag = false;

  constructor(
    private router: Router,
    public auth: AuthService,
    private route: ActivatedRoute,
    public meterUnitDialog: MatDialog,
    private unitsApi: UnitsApi,
    @Inject(LOCALE_ID) private locale: string
  ) {
    localStorage.setItem("path", router.url);
  }

  ngOnInit() {
    this.loginUser = new LoginUser();
    this.meterUnitData = [];
    this.getMeterUnitFinished = false;

    this.searchKeyChanged
      .debounceTime(300) // wait 300ms after the last event before emitting last event
      .subscribe((str) => {
        this.searchKeyString = str;
        this.filterResult();
      });

    this.loginUser = Const.loginUser;
    this.mjitUserFlag = Const.mjitUser;
    this.adminUserFlag = Const.adminUser;
    this.onGetMeterUnitData();
  }

  filterResult() {
    if (this.searchKeyString === "") {
      this.filteredMeterUnitData = this.meterUnitData;
      return;
    }

    this.filteredMeterUnitData = this.meterUnitData.filter((item) =>
      item.type.includes(this.searchKeyString)
    );
  }

  search(text: string) {
    this.searchKeyChanged.next(text);
  }

  onGetMeterUnitData() {
    this.getMeterUnitFinished = false;
    this.unitsApi.getUnitsAll().subscribe((res) => {
      let jsonStr = JSON.stringify(res);
      let jsonObj = JSON.parse(jsonStr);
      let data = jsonObj.result.units;

      this.getMeterUnitFinished = true;

      this.meterUnitData = data.sort(function (a: Unit, b: Unit) {
        let left = new Date(a.updated_at);
        let right = new Date(b.updated_at);
        return right.getDate() - left.getDate();
      });
      this.filteredMeterUnitData = this.meterUnitData;
      this.displayedColumns = [
        "unit",
        "createdBy",
        "createdAt",
        "updatedBy",
        "updatedAt",
        "editButton",
        "deleteButton",
      ];
      this.getMeterUnitFinished = true;
    });
  }

  onClickAddMeterUnit() {
    const dialogRef = this.meterUnitDialog.open(MeterUnitAddDialogComponent, {
      width: "650px",
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === "close") {
        // 最小限の更新になるように要改良

        this.onGetMeterUnitData();
      }
    });
  }

  onClickUpdateMeterUnit(unit: Unit) {
    const dialogRef = this.meterUnitDialog.open(MeterUnitEditDialogComponent, {
      width: "650px",
      data: unit,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult === "close") {
        // 最小限の更新になるように要改良
        this.onGetMeterUnitData();
      }
    });
  }

  onClickDeleteMeterUnit(unit: Unit) {
    let contentMsg = unit.type + "を削除します。よろしいですか。";
    const messageInfo = new MeterConfirmDialogInfo(
      "メーター単位削除確認",
      contentMsg
    );
    const confirmDialog = this.meterUnitDialog.open(
      CommonConfirmDialogComponent,
      {
        width: "400px",
        data: messageInfo,
      }
    );

    confirmDialog.afterClosed().subscribe((result) => {
      if (result === "Yes") {
        let params = new HttpParams();
        params.set("type", "");

        this.unitsApi.deleteUnit(unit.id, params).subscribe((res) => {
          let jsonStr = JSON.stringify(res);
          let jsonObj = JSON.parse(jsonStr);

          if (jsonObj.status == 200) {
            this.onGetMeterUnitData();
          }
        });
      }
    });
  }
}
